import type { MutableRefObject } from "react";

import type { PlaybackBounds, PlaybackState } from "@/lib/timeline/playback";

export function pausePlayback(
  playbackRef: MutableRefObject<PlaybackState | null>,
  setTransport: (next: { playing: boolean; speed: number }) => void,
): void {
  const current = playbackRef.current;
  if (current === null || !current.playing) {
    return;
  }
  playbackRef.current = { ...current, playing: false };
  setTransport({ playing: false, speed: current.speed });
}

export function clampPlayhead(playheadMs: number, bounds: PlaybackBounds): number {
  return Math.min(bounds.endMs, Math.max(bounds.startMs, playheadMs));
}

export function seekPlayback(
  playbackRef: MutableRefObject<PlaybackState | null>,
  bounds: PlaybackBounds,
  playheadMs: number,
): void {
  const current = playbackRef.current;
  if (current === null) {
    return;
  }
  playbackRef.current = {
    ...current,
    playheadMs: clampPlayhead(playheadMs, bounds),
  };
}
